import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";
import { Select, FormControl, InputLabel } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { BASE_URL } from "../../urlConfig/Url";

const PlantMaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [cid, setCID] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState(false);
  const [plantCode, setPlantCode] = useState("");
  const [plantCodeError, setPlantCodeError] = useState(false);
  const [plantName, setPlantName] = useState("");
  const [plantNameError, setPlantNameError] = useState(false);
  const [plantAddress, setPlantAddress] = useState("");
  const [plantAddressError, setPlantAddressError] = useState(false);
  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState(false);
  const [state, setState] = useState("");
  const [stateError, setStateError] = useState(false);
  const [status, setStatus] = useState("");
  const [statusError, setStatusError] = useState(false);
  

  const [companies, setCompanies] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [cName, setCName] = useState([]);
  const [formMode, setFormMode] = useState("initial");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchCompanies();
    fetchCompaniesName();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(BASE_URL + "/api/master/getAllPlants");
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesName = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/getCompanyName"
      );
      if (response.data.success) {
        setCName(response.data.response);
      }
    } catch (error) {
      toast.error("Error fetching company data:", error);
    }
  };

  const validateForm = () => {
    let isValid = true;
    if (companyName === "") {
      setCompanyNameError(true);
      isValid = false;
    }else{
      setCompanyNameError(false);
    }
    if (plantCode === "") {
      setPlantCodeError(true);
      isValid = false;
    }else{
      setPlantCodeError(false);
    }
    if (plantName === "") {
      setPlantNameError(true);
      isValid = false;
    }else{
      
    }
    if (plantAddress === "") {
      setPlantAddressError(true);
      isValid = false;
    }else{
      setPlantAddressError(false);
    }
    if (city === "") {
      setCityError(true);
      isValid = false;
    }else{
      setCityError(false);
    }
    if (state === "") {
      setStateError(true);
      isValid = false;
    }else{
      setStateError(false);
    }
    if (status === "") {
      setStatusError(true);
      isValid = false;
    }else{
      setStatusError(false);
    }

    return isValid;
    
  }

  const onSubmit = async () => {
    if (validateForm()) {
    const data = {
      ComPCode: companyName,
      PlantCode: plantCode,
      PlantName: plantName,
      Address: plantAddress,
      City: city,
      State: state,
      Status: status,
      Barcode: plantCode,
      Createdby: getName().Name,
    };
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/insertPlantDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    }
  } else {
    toast.error("Please fill in all required fields.");
  }
  };

  const onUpdate = async () => {
    const data = {
      PlantID: cid,
      CompanyCode: companyName,
      PlantCode: plantCode,
      PlantName: plantName,
      Address: plantAddress,
      City: city,
      State: state,
      Status: status,
      Updatedby: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/updatePlantDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating company data:", error);
      toast.error("An error occurred while updating the company.");
    }
  };

  const resetForm = () => {
    setCID("");
    setCompanyName("");
    setPlantCode("");
    setPlantName("");
    setPlantAddress("");
    setCity("");
    setState("");
    setStatus("");
  };


  const stopErrorHelper =()=>{
    setCompanyNameError(false);
    setPlantCodeError(false);
    setPlantNameError(false);
    setPlantAddressError(false);
    setCityError(false);
    setStateError(false);
    setStatusError(false);
  }

  const handleAddNew = () => {
    setFormMode("add");
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
    stopErrorHelper();
  };

  useEffect(() => {
    const result = companies.filter((company) =>
      Object.entries(company).some(([key, value]) => {
        // Skip null or undefined values
        if (value == null) return false;

        // Convert to string and compare
        return value
          .toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
      })
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.trim());
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowSelect = (company) => {
    setCID(company.PlantID);
    setPlantCode(company.PlantCode);
    setPlantName(company.PlantName);
    setPlantAddress(company.Address);
    setCity(company.City);
    setState(company.State);
    setStatus(company.Status);
    setCompanyName(company.CompanyName);
    setFormMode("edit");
    stopErrorHelper();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <>
      <Container maxWidth="lg">
        <Box sx={{ mt: 1, mb: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              to="/dashboard/dashbordhome"
              style={{
                textDecoration: "none",
                color: theme.palette.primary.main,
              }}
            >
              Home
            </Link>
            <Typography color="textPrimary">Plant Master</Typography>
          </Breadcrumbs>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
              Plant Master (* Fields Are Mandatory)
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Company(*)"
                  name="Company"
                  fullWidth
                  size="small"
                  value={companyName}
                  error={companyNameError}
                  helperText={companyNameError ? "Company is required" : ""}
                  onChange={(e) => setCompanyName(e.target.value)}
                  disabled={formMode === "initial" || formMode === "edit"}
                >
                  {cName.map((company) => (
                    <MenuItem
                      key={company.CompCode}
                      value={company.CompanyName}
                    >
                      {company.CompanyName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Plant Code (*)"
                  name="Plant Code"
                  fullWidth
                  size="small"
                  value={plantCode}
                  error={plantCodeError}
                  helperText={plantCodeError ? "Plant Code is required" : ""}
                  onChange={(e) => setPlantCode(e.target.value)}
                  disabled={formMode === "initial" || formMode === "edit"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Plant Name (*)"
                  name="Plant Name"
                  fullWidth
                  size="small"
                  value={plantName}
                  error={plantNameError}
                  helperText={plantNameError ? "Plant Name is required" : ""}
                  onChange={(e) => setPlantName(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Plant Address (*)"
                  name="Plant Address"
                  fullWidth
                  size="small"
                  value={plantAddress}
                  error={plantAddressError}
                  helperText={
                    plantAddressError ? "Plant Address is required" : ""
                  }
                  
                  onChange={(e) => setPlantAddress(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="City  (*)"
                  name="City "
                  fullWidth
                  size="small"
                  value={city}
                  error={cityError}
                  helperText={cityError ? "City is required" : ""}
                  onChange={(e) => setCity(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="State (*)"
                  name="State"
                  fullWidth
                  size="small"
                  value={state}
                  error={stateError}
                  helperText={stateError ? "State is required" : ""}
                  onChange={(e) => setState(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Status(*)"
                  name="Status"
                  fullWidth
                  size="small"
                  value={status}
                  error={statusError}
                  helperText={statusError ? "Status is required" : ""}
                  onChange={(e) => setStatus(e.target.value)}
                  disabled={formMode === "initial"}
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Deactive">Deactive</MenuItem>
                </TextField>
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" mt={5} spacing={1}>
              {formMode === "initial" && (
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddNew}
                  >
                    <AddIcon />
                    Add New
                  </Button>
                </Grid>
              )}

              {formMode === "add" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onSubmit}>
                      <AddIcon />
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}

              {formMode === "edit" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onUpdate}>
                      <ChangeCircleIcon />
                      Update
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: 100 }}
              >
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                  labelId="rows-per-page-label"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  label="Rows per page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: 250 }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Company Name </th>
                    <th>Plant Code</th>
                    <th>Plant Name</th>
                    <th>Plant Address</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Created On</th>
                    <th>Updated By</th>
                    <th>Updated On</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRows.map((company) => (
                    <tr key={company.PlantID}>
                      <td data-label="Select">
                        <button onClick={() => handleRowSelect(company)}>
                          Select
                        </button>
                      </td>
                      <td data-label="Company Name ">{company.CompanyName}</td>
                      <td data-label="Plant Code">{company.PlantCode}</td>
                      <td data-label="Plant Name">{company.PlantName}</td>
                      <td data-label="Plant Address">{company.Address}</td>
                      <td data-label="City">{company.City}</td>
                      <td data-label="State">{company.State}</td>
                      <td data-label="Status">{company.Status}</td>
                      <td data-label="Created By">{company.Createdby}</td>
                      <td data-label="Created On">
                        {new Date(company.CreatedOn).toLocaleString()}
                      </td>
                      <td data-label="Updated By">{company.Updatedby}</td>
                      <td data-label="Updated On">
                        {company.UpdatedOn
                          ? new Date(company.UpdatedOn).toLocaleString()
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ marginRight: 2 }}>
                Showing {(page - 1) * rowsPerPage + 1} to{" "}
                {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                {filteredRows.length} entries
              </Typography>
              <Pagination
                count={Math.ceil(filteredRows.length / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
                size="small"
              />
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default PlantMaster;
